/*
 * @Author: xuejian3721
 * @Date: 2023-10-23 09:44:44
 * @LastEditors: xuejian3721
 * @LastEditTime: 2026-04-20 08:44:28
 */
import api from '@/api/im-chat'
import { resCode } from '@/utils/res-types'
import { defaultMsgBody, msgShowTypes, formartMsgs } from '@/utils/msg-types'
import { setQaStyle, setQuestionStyle } from '@/utils/qaMsg-types'
import { setOrderStyle } from '@/utils/orderMsg-types'
import { setBackstopStyle } from '@/utils/backstopMsg-types'
import { setSelfServiceMsgStyle, setNoInvoiceStyle } from '@/utils/selfServiceMsg-types'
import { setCommodityCardStyle } from '@/utils/commodityCardMsg-types'
import { setCustomerStyle } from '@/utils/customerMsg-types'
import { MessageBox, Message } from 'element-ui'
import { loopMsgByPoll, startLoopMsgByPoll, stopLoopMsgByPoll, sendMsgByPoll } from './polling'
import chatAgent from './chatAgent'
import { getToken, getGrayscaleMark, getGrayscaleMarkValue, getGrayscaleMarkvalue } from '@/utils/auth'
import { generateTimestampPlusRandom } from '@/utils/common'
import { parseHashQuerys } from '@/utils/location'
import { sendAiMessage, abortFetchEventSource } from './ai-fetch-copy'

export default {
  loopMsgByPoll,
  startLoopMsgByPoll,
  stopLoopMsgByPoll,
  sendMsgByPoll,
  sendAiMessage,
  abortFetchEventSource,
  ...chatAgent,
  async initChatBaseData({ rootState, state, commit, dispatch }) {
    const shouldInitMerge = !state.chatInfo.sessionId
    await commit('setCurrentChatMsgs', [])
    await commit('setInitCurrentHistoryMsgs', [])
    await commit('setInitPendingChatMsgs', [])
    await commit('setInitCurrentHistoryResolved', false)
    await commit('setInitMsgSource', '')
    await commit('SET_INIT_MERGING_MSGS', shouldInitMerge)
    await dispatch('getChatBaseData')
    await dispatch('getDialogInfo')
    await dispatch('getCurrentMsg')
  },
  async getChatBaseData({ state, commit, dispatch }) {
    return api.getChatBaseData().then(res => {
      if (res.code == resCode.success) {
        commit('updateChatInfo', {
          sc: res.data.channelId,
          appId: res.data.appId,
          userId: res.data.uid,
          customerShowType: res.data.customerShowType,
          customWebSocketSwitch: res.data.customWebSocketSwitch,
          pageId: state.nonChatlist ? state.chatInfo.pageId : res.data.customerPageId
        })
        commit('updateUid', res.data.uid)
      } else if (res.code === resCode.incomingFailure) {
        try {
          commit('setRefreshIndexInit', false)
          dispatch('stopLoopMsg')
          MessageBox.confirm(res.msg, '提示', {
            confirmButtonText: '刷新',
            cancelButtonText: '取消',
            showClose: false,
            showCancelButton: false,
            closeOnClickModal: false
          })
            .then(() => {
              location.reload()
            })
            .catch(() => {})
        } catch (error) {
          console.log(error)
        }
      }
    })
  },
  async getDialogInfo({ commit, dispatch, getters }, noFirst = false) {
    return api.getDialogInfo(noFirst).then(res => {
      if (res.code == resCode.success) {
        commit('updateChatInfo', {
          sessionId: res.data.id,
          userId: res.data.uid,
          isClose: false,
          isJoinKefu: false,
          dialogType: res.data.dialogType,
          businessPartCode: res.data.businessPartCode
        })
        commit('updateKefuid', res.data.kefuid)
        commit('updateUserAvatar', res.data.customHeadImg)
        dispatch('getAiSwitch', res.data.businessPartCode)
        if (getters.isCustomWebSocketSwitch) {
          dispatch('sendMessage', {
            msgType: 9,
            dialogId: res.data.id,
            body: {
              content: {}
            }
          })
        }
      }
    })
  },
  async getAiSwitch({ commit, state, dispatch }, businessPartCode) {
    // 获取AI开关
    return api.getAiSwitch(businessPartCode).then(res => {
      console.log(res, 'res++AI开关')
      if (res.code === 1) {
        if (res.data === 1) {
          commit('updateIsAiMsgOpen', true)
        } else {
          commit('updateIsAiMsgOpen', false)
        }
      } else {
        commit('updateIsAiMsgOpen', false)
      }
    })
  },
  async getCurrentMsg({ state, dispatch, commit }) {
    // 会话中加载历史消息
    if ([1, 2, 5].includes(state.chatInfo.dialogType)) {
      await api
        .getCurrentMsg()
        .then(res => {
          if (res.code == resCode.success) {
            commit('setInitMsgSource', 'current_history')
            try {
              res.data.forEach(msg => {
                dispatch('formatReceiveMsg', msg)
              })
            } finally {
              commit('setInitMsgSource', '')
            }
          }
        })
        .finally(() => {
          if (state.isInitMergingMsgs) {
            commit('setInitCurrentHistoryResolved', true)
          }
        })
      return
    }
    if (state.isInitMergingMsgs) {
      commit('setInitCurrentHistoryResolved', true)
    }
  },
  /**
   * 更新ca客服信息
   */
  async updateCA({ rootState, commit }) {},
  /**
   * 自动判断加入客服类型
   */
  async joinKefu({ state, dispatch }) {
    // 会话未进线状态或未成功加入客服则尝试进线,dialogType初始化,并且没有调isJoinKefu，并且没有报320
    if (state.chatInfo.dialogType === 0 && !state.chatInfo.isJoinKefu && !state.chatInfo.pageExpired) {
      if (state.chatInfo.hasCA) {
        // 加入ca客服
        await dispatch('joinKefuManual', { type: 2 })
      } else {
        // 加入普通客服
        await dispatch('joinKefuManual', { type: 1 })
      }
    } else {
      return true
    }
  },
  /**
   * 指定加入客服的类型
   * kefuType 1-普通客服 2-ca客服
   * close 是否关闭旧的会话
   */
  async joinKefuManual({ state, commit, dispatch }, { type = 1, close = false }) {
    let res = await api.joinChat()
    if (res.code == resCode.success) {
      commit('updateChatInfo', { isJoinKefu: true })
      //可能前一个会话是留言并指派坐席,在进线又是留言此时客服id不为空
      if (res.data && res.data.kefuid > 0 && (state.chatInfo.dialogType === 0 || state.chatInfo.dialogType == 1)) {
        commit('updateChatInfo', { dialogType: 1 })
      }
      dispatch('formatReceiveMsg', res.data)
    }
  },
  async updateDialogInfo({ state, dispatch, commit }) {
    // 重新进会话需要更新会话数据
    if (state.chatInfo.isClose) {
      // 重新加载会话，不用加载beforeDialog接口
      commit('setReloadConversation', 2)
      await dispatch('getDialogInfo', true)
    } else {
      return true
    }
  },
  startLoopMsg({ state, commit, dispatch, getters }) {
    dispatch('connectWebSocket') // 连接 WebSocket
    if (!getters.isCustomWebSocketSwitch) {
      if (!state.nonChatlist) commit('evEventChat', 'evEventChatList')
      dispatch('startLoopMsgByPoll')
    }
  },
  stopLoopMsg({ dispatch, getters }) {
    dispatch('closeWebSocket')
    if (!getters.isCustomWebSocketSwitch) {
      dispatch('stopLoopMsgByPoll')
    }
  },
  // 连接 WebSocket
  connectWebSocket({ state, dispatch }) {
    dispatch('closeWebSocket')
    const { customCode, platformId } = parseHashQuerys()
    const { VUE_APP_baseURL_POP_websocket } = process.env
    const token = customCode || getToken()
    const requestId = generateTimestampPlusRandom()
    const { userId, sc, sessionId } = state.chatInfo
    let url = `${VUE_APP_baseURL_POP_websocket}?token=${token}&requestId=${requestId}&uid=${userId}&dialogId=${sessionId}&sc=${sc}&platformId=${platformId}`
    const grayscaleMark = getGrayscaleMark()
    const grayscaleValue = getGrayscaleMarkValue() || getGrayscaleMarkvalue() || ''
    if (grayscaleMark && grayscaleValue) {
      url += `&${grayscaleMark}=${grayscaleValue}`
    }
    dispatch('initWebSocket', { url })
      .then(() => {
        console.log('++++', 'WebSocket连接已初始化', url)
      })
      .catch(error => {
        console.error('++++ WebSocket初始化失败:', error)
      })
  },
  async sendMsg({ state, commit, dispatch, getters }, content) {
    if (!state.chatInfo.pageId || !state.chatInfo.sessionId) {
      Message.warning('缺少必要参数')
      return false
    }
    // 检查 WebSocket 是否可用
    const wsReady = state.wsService && state.wsService.socket && state.wsService.socket.readyState === WebSocket.OPEN
    if (!wsReady) {
      MessageBox.confirm('会话连接失败，请尝试刷新页面重新连接！', '提示', {
        showClose: false,
        closeOnClickModal: false,
        confirmButtonText: '刷新',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          location.reload()
        })
        .catch(() => {})
      return false
    }
    // 消息发送中
    if (state.isSending) {
      Message.warning('正在发送请稍后')
      return false
    }
    // 空内容
    if (!content) {
      Message.warning('请输入内容')
      return false
    }
    // 页面id不匹配	用户在新页面打开在线客服时，旧页面提示消息
    if (state.chatInfo.pageExpired) {
      MessageBox('您已在其他页面打开了客服系统，请关闭此页面')
      return false
    }

    commit('setIsSending', true)

    try {
      await dispatch('updateDialogInfo')
    } catch (error) {
      commit('setIsSending', false)
    }

    return dispatch('sendMsgByPoll', content)
  },
  pushMsgs({ commit, state }, msgs) {
    if (state.initMsgSource === 'current_history') {
      if (state.isInitMergingMsgs) {
        commit('pushInitCurrentHistoryMsgs', msgs)
      } else {
        commit('pushCurrentChatMsgs', msgs)
        commit('emit', 'evScrollToBottom')
      }
      return
    }

    if (state.isInitMergingMsgs) {
      commit('pushInitPendingChatMsgs', msgs)
      return
    }

    // 推送消息并滚动到底部
    commit('pushCurrentChatMsgs', msgs)
    commit('emit', 'evScrollToBottom')
  },
  formatReceiveMsg({ rootState, state, commit, dispatch, getters }, msg) {
    // 格式化消息数据
    const msgType = Number(msg.type)

    // 前置处理，隐藏暂时性消息
    switch (msgType) {
      case 301:
      case 330:
      case 333:
      case 335:
      case 403:
      case 410:
      case 413:
      case 416:
      case 421:
      case 501:
      case 502:
      case 601:
      case 602:
      case 603: {
        state.currentChatMsgs.forEach(msg => {
          if (msg.temporary) {
            msg.showType = msgShowTypes.nope
            msg.msgId = msg.messageId = null
          }
        })
        break
      }
    }

    // 忽略空内容和重复消息 103问答 106订单 212问答兜底 350问答 900是否已读 901,902撤回不需要发送内容
    if (
      msg.content &&
      msg.dialogid === state.chatInfo.sessionId &&
      !state.currentChatMsgs.find(val => val.msgId && val.msgId == msg.msgId) &&
      ![103, 106, 107, 108, 212, 350, 351, 900, 901, 902, 370].includes(msgType)
    ) {
      dispatch('pushMsgs', formartMsgs([msg]))
      if (rootState.pageIsVisible) {
        document.title = '【您有新的未读消息】'
      }
    }

    switch (msgType) {
      // 订单
      case 106:
        if (
          msg.originalContent &&
          msg.dialogid === state.chatInfo.sessionId &&
          !state.currentChatMsgs.find(val => val.msgId && val.msgId == msg.msgId)
        ) {
          try {
            const orderObj = JSON.parse(msg.originalContent)
            if (orderObj !== null && typeof orderObj === 'object' && Object.keys(orderObj).length > 0) {
              const content = setOrderStyle(orderObj)
              if (content) {
                dispatch('pushMsgs', formartMsgs([{ ...msg, content }]))
              }
            }
          } catch (error) {
            console.error('Error parsing JSON:', '查询订单消息异常')
          }
        }
        break
      // 首营资料
      case 370:
        if (msg.originalContent) {
          try {
            const orderObj = JSON.parse(msg.originalContent)
            if (orderObj !== null && typeof orderObj === 'object' && Object.keys(orderObj).length > 0) {
              const content = setOrderStyle(orderObj)
              if (content) {
                dispatch('pushMsgs', formartMsgs([{ ...msg, content }]))
              }
            }
          } catch (error) {
            console.error('Error parsing JSON:', '查询订单消息异常')
          }
        }
      // 商品卡片
      case 107:
        if (
          msg.originalContent &&
          msg.dialogid === state.chatInfo.sessionId &&
          !state.currentChatMsgs.find(val => val.msgId && val.msgId == msg.msgId)
        ) {
          try {
            const orderObj = JSON.parse(msg.originalContent)
            if (orderObj !== null && typeof orderObj === 'object' && Object.keys(orderObj).length > 0) {
              const content = setCommodityCardStyle(orderObj)
              if (content) {
                dispatch('pushMsgs', formartMsgs([{ ...msg, content }]))
              }
            }
          } catch (error) {
            console.error('Error parsing JSON:', '查询商品卡片消息异常')
          }
        }
        break
      // 灯塔选择客户
      case 108:
        if (
          msg.originalContent &&
          msg.dialogid === state.chatInfo.sessionId &&
          !state.currentChatMsgs.find(val => val.msgId && val.msgId == msg.msgId)
        ) {
          try {
            const customerObj = JSON.parse(msg.originalContent)
            if (customerObj !== null && typeof customerObj === 'object' && Object.keys(customerObj).length > 0) {
              const content = setCustomerStyle(customerObj)
              if (content) {
                dispatch('pushMsgs', formartMsgs([{ ...msg, content }]))
              }
            }
          } catch (error) {
            console.error('Error parsing JSON:', '查询灯塔客户消息异常')
          }
        }
        break
      // 主动发起
      case 210:
        commit('updateChatInfo', {
          dialogType: 5
        })
        break
      // 问答兜底
      case 212:
        if (msg.originalContent) {
          commit('setBackstopObj', JSON.parse(msg.originalContent))
          const content = setBackstopStyle()
          if (content) {
            dispatch('pushMsgs', formartMsgs([{ ...msg, content }]))
          }
        }
        break
      case 308:
        //接入客服
        commit('updateChatInfo', {
          dialogType: 1
        })
        break
      case 320:
        // 页面id不匹配	用户在新页面打开在线客服时，旧页面提示消息
        // 停止轮询
        commit('updateChatInfo', {
          pageExpired: true
        })
        MessageBox('您已在其他页面打开了客服系统，请关闭此页面')
        dispatch('stopLoopMsg')
        dispatch('pushMsgs', [
          defaultMsgBody({
            msg: '已在其他页面打开，结束读取消息',
            showType: msgShowTypes.warning
          })
        ])
        break
      case 330:
        // 转留言状态
        commit('updateChatInfo', {
          dialogType: 2
        })
        break
      case 334:
        // //客户绑定
        commit('updateChatInfo', {
          userId: msg.newUserId
        })
        break
      case 339:
        dispatch('pushMsgs', [
          defaultMsgBody({
            msg: '专属客服当前不在线，已为您分配普通客服',
            showType: msgShowTypes.warning
          })
        ])
        dispatch('joinKefuManual', { type: 1 })
        break
      case 341: {
        commit('updateChatInfo', {
          dialogType: 2
        })
        break
      }
      // 问答-问题
      case 350:
        if (msg.originalContent) {
          commit('setQaList', JSON.parse(msg.originalContent))
          const content = setQaStyle(true)
          if (content) {
            dispatch('pushMsgs', formartMsgs([{ ...msg, content }]))
          }
        }
        break
      // 问答-答案
      case 351:
        if (msg.originalContent) {
          commit('setQuestionCache', { msgId: msg.msgId, startIndex: 0, qaList: JSON.parse(msg.originalContent) })
          const content = setQuestionStyle(msg.msgId)
          if (content) {
            dispatch('pushMsgs', formartMsgs([{ ...msg, content }]))
          }
        }
        break
      // 自助查询-按钮列表
      case 353:
        if (msg.originalContent) {
          dispatch('pushMsgs', formartMsgs([{ ...msg, content: msg.originalContent }]))
        }
        break
      // 自助查询-点击我的订单
      case 361:
        commit('emit', 'evAppSelfServiceOrder')
        break
      // 自助查询-订单无发票
      case 362:
        if (msg.originalContent) {
          const content = setNoInvoiceStyle(msg.originalContent)
          if (content) {
            dispatch('pushMsgs', formartMsgs([{ ...msg, content }]))
          }
        }
        break
      case 354: // 自助查询-点击审核进度
      case 363: // 自助查询-点击查询订单
        if (msg.originalContent) {
          commit('setSelfServiceObj', JSON.parse(msg.originalContent))
          const content = setSelfServiceMsgStyle()
          if (content) {
            dispatch('pushMsgs', formartMsgs([{ ...msg, content }]))
          }
        }
        break
      case 368: // 客服转接超时处理
        state.currentChatMsgs.map(m => {
          // 隐藏客服超时没有回复转接提醒
          if (m.type === 365) {
            m.showType = msgShowTypes.nope
            m.msgId = m.messageId = null
          }
        })
        break
      case 369: // 客服转接超时处理
        // 更新会话状态
        commit('updateChatInfo', {
          dialogType: 1,
          isClose: false
        })
        // 重新加载会话，不用加载beforeDialog接口
        commit('setReloadConversation', 2)
        // 更新id
        if (state.chatInfo.sessionId !== msg.dialogid) {
          commit('updateChatInfo', { sessionId: msg.dialogid })
          if (getters.isCustomWebSocketSwitch) {
            dispatch('sendMessage', {
              msgType: 9,
              dialogId: msg.dialogid,
              body: {
                content: {}
              }
            })
          }
        }
        break
      // 自助查询-点击灯塔-咨询订单
      case 371:
        commit('emit', 'evAppLighthouseOrder')
        break
      // 自助查询-点击灯塔-咨询客户
      case 372:
        commit('emit', 'evAppConsultCustomer')
        break
      case 403:
        // 更新会话状态
        commit('updateChatInfo', {
          dialogType: 1,
          isClose: false
        })
        break
      // 转留言
      case 420:
        commit('updateChatInfo', {
          dialogType: 2
        })
        break
      case 421:
        // 更新会话状态
        commit('updateChatInfo', {
          dialogType: 1,
          isClose: false
        })
        // 如果是消息类型421，重新加载会话时，判断是否重新加载beforeDialog接口
        commit('setReloadConversation', 1)
        // 更新id
        const { sessionId } = state.chatInfo
        if (sessionId !== msg.dialogid) {
          commit('updateChatInfo', { sessionId: msg.dialogid })
          if (getters.isCustomWebSocketSwitch) {
            dispatch('sendMessage', {
              msgType: 9,
              dialogId: msg.dialogid,
              body: {
                content: {}
              }
            })
          }
        }
        break
      case 702:
        Message.warning(msg.content)
        break
      case 900:
        // 消息已读 msgStatus等于0表示未读，1表示已读
        state.currentChatMsgs = state.currentChatMsgs.map(msg => {
          if (msg.msgStatus === 0) {
            return { ...msg, msgStatus: 1 }
          } else {
            return msg
          }
        })
        break
      case 901: // 撤回
      case 902: // 撤回-重新编辑 msgStatus等于-1表示撤回，-2表示撤回并且显示重新编辑按钮
        const index = state.currentChatMsgs.findIndex(val => val.messageId == msg.recallMessageId)
        if (index !== -1) {
          const msgItem = state.currentChatMsgs[index]
          Object.assign(msgItem, {
            showType: msgShowTypes.recall,
            type: msg.type,
            msg: msg.content,
            msgStatus: msg.msgStatus
          })
        }
        break
      case 600998:
        const _index = state.currentChatMsgs.findIndex(val => val.messageId == msg.messageId)
        if (_index !== -1) {
          const msgItem = state.currentChatMsgs[_index]
          Object.assign(msgItem, {
            msg: msg.content,
            originalContent: msg.content,
            component: msg.component,
            messageTag: { aiReplyTag: true }
          })
          commit('emit', 'evScrollToBottom')
          commit('setIsSending', false)
        } else {
          dispatch('pushMsgs', formartMsgs([{ messageId: msg.messageId, content: msg.content }]))
        }
        break
      default:
        // 发送已读通知
        if (getters.isCustomWebSocketSwitch && msg.dialogid === state.chatInfo.sessionId) {
          dispatch('sendMessage', {
            msgType: 8,
            dialogId: msg.dialogid,
            body: {
              subType: 5,
              content: {
                messageIdList: [msg.messageId]
              }
            }
          })
        }
        break
    }

    // 会话未关闭状态下触发
    if (!state.chatInfo.isClose) {
      switch (msgType) {
        case 335:
          dispatch('setChatAsClose')
          break
      }
      // 当前会话执行
      if (msg.dialogid === state.chatInfo.sessionId) {
        // 结束会话，更新会话状态
        switch (msgType) {
          case 410:
          case 413:
          case 416:
          case 501:
          case 502:
          case 601:
          case 602:
            setTimeout(() => {
              dispatch('setChatAsClose')
            }, 3000)
            break
          case 603:
            dispatch('setChatAsClose')
            break
        }
        // 结束会话消息提示
        switch (msgType) {
          case 416:
          case 501:
          case 502:
          case 601:
          case 602:
          case 603:
          case 604:
            dispatch('pushMsgs', [
              defaultMsgBody({
                // msg: "您的对话已结束",
                msg: msg.content || '您的对话已结束',
                showType: msgShowTypes.tips
              })
            ])
            commit('updateConversationId', '')
            commit('updateTaskId', '')
            break
        }
        switch (msgType) {
          case 908:
          case 909:
          case 1001:
            // isHide为true隐藏之前邀评，显示当前的邀评
            if (msg.msgExt && Object.keys(msg.msgExt).length > 0) {
              const { isHide } = msg.msgExt
              if (isHide) {
                state.currentChatMsgs = state.currentChatMsgs.map(m => {
                  // 对所有类型为 908/909/1001 的消息按钮进行隐藏
                  if ([908, 909, 1001].includes(m.type)) {
                    // 对当前消息按钮进行显示
                    if (m.messageId === msg.messageId) {
                      return { ...m, msgExt: { ...m.msgExt, isHide: false } }
                    } else {
                      return { ...m, msgExt: { ...m.msgExt, isHide: true } }
                    }
                  }
                  return m
                })
              }
            }
            break
          case 1002: {
            // 进线后收到1002，置灰最近一条未评价的1001邀评消息
            for (let i = state.currentChatMsgs.length - 1; i >= 0; i--) {
              const msgItem = state.currentChatMsgs[i]
              if (msgItem.type === 1001 && !msgItem.review) {
                msgItem.review = true
                break
              }
            }
            break
          }
        }
      }
    }
  },
  setChatAsClose({ commit }) {
    // 设置会话为关闭状态
    commit('updateChatInfo', {
      isClose: true,
      dialogType: 0,
      isJoinKefu: false
    })
  },
  closeDialog({ state, dispatch }) {
    if (
      !state.chatInfo.isClose &&
      (state.chatInfo.dialogType == 1 || state.chatInfo.dialogType === 0) &&
      !state.chatInfo.pageExpired
    ) {
      api.closeDialog().then(res => {
        if (res.code == resCode.success && res.data) {
          dispatch('formatReceiveMsg', res.data)
        }
      })
    }
  },
  estimation({ commit }) {
    // 检测是否已发送过评价
    api.isEstimated().then(res => {
      if (res.code == resCode.success && !res.data) {
        // 发送满意度评价
        commit('emit', 'evEstimation')
      }
    })
  },
  checkEstimationTasks({ state, commit, dispatch }) {
    // 检查评价队列是否需要继续弹出
    const task = state.estimationTasks.find(val => !val.finished)
    if (task) {
      commit('updateEstimationSessionId', task.id)
      dispatch('estimation')
    }
  },
  getSYDoc({ state, commit, dispatch }) {
    // 检查评价队列是否需要继续弹出
    console.log(state.chatInfo)
    api.getFirstBusinessMaterials().then(res => {
      $track('kf_customer_session_download_obtain_ck', {
        customer_id: state.chatInfo.userId
      })
    })
  },
  sendEvaluate({ state, commit, dispatch }) {
    api.apiSendAiEvaluateMessage().then(res => {
    })
  }
}
